function Log() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="3 3 15 15"
      fill="currentColor"
    >
      <path d="M6.39683 14.3936H7.87117V12.9193H6.39683V14.3936ZM6.39683 11.1564H7.87117V9.68208H6.39683V11.1564ZM6.39683 7.91925H7.87117V6.4449H6.39683V7.91925ZM9.66604 14.2814H14.4096V13.0314H9.66604V14.2814ZM9.66604 11.0442H14.4096V9.79427H9.66604V11.0442ZM9.66604 7.80706H14.4096V6.55708H9.66604V7.80706ZM3.33594 17.5026V3.33594H17.5026V17.5026H3.33594ZM4.58592 16.2526H16.2526V4.58592H4.58592V16.2526Z" />
    </svg>
  );
}

export default Log;
